import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Productie/RetetarModels.cs ----------

export type BomStatus = 'Draft' | 'PendingApproval' | 'Activa' | 'Arhivata' | 'Respinsa'

export interface BomListItem {
  id: string; code: string; version: number; productArticleId: string; productArticleCode: string
  productArticleDescription: string; clientId: string | null; clientName: string | null
  status: BomStatus; validFrom: string; validTo: string | null
}

export interface BomLine {
  id: string; componentArticleId: string; componentArticleCode: string; componentArticleDescription: string
  quantityPerThousand: number; unitOfMeasureId: string; unitOfMeasureCode: string; tolerancePercent: number | null
  isRequired: boolean; notes: string | null; componentStandardCost: number | null
}

export type SaveBomLinePayload = Pick<
  BomLine, 'componentArticleId' | 'quantityPerThousand' | 'unitOfMeasureId' | 'tolerancePercent' | 'isRequired' | 'notes'
>

export interface BomDetail {
  id: string; code: string; version: number; isCurrentVersion: boolean; previousVersionId: string | null
  productArticleId: string; productArticleCode: string; productArticleDescription: string
  clientId: string | null; clientName: string | null; validFrom: string; validTo: string | null
  status: BomStatus; changeReason: string | null
  thermoformingLossPercent: number | null; cuttingLossPercent: number | null; scrapLossPercent: number | null
  conversionCostPerThousand: number | null; processTemperatureC: number | null; cycleTimeSeconds: number | null
  pressureBar: number | null; wallThicknessMm: number | null; qualityToleranceNotes: string | null
  lines: BomLine[]; componentsCostPerThousand: number; totalCostPerThousand: number
}

export interface BomHistoryEntry { id: string; version: number; status: BomStatus; validFrom: string; validTo: string | null; changeReason: string | null; createdAt: string }

export interface SaveBomPayload {
  productArticleId: string; clientId: string | null; validFrom: string; validTo: string | null
  thermoformingLossPercent: number | null; cuttingLossPercent: number | null; scrapLossPercent: number | null
  conversionCostPerThousand: number | null; processTemperatureC: number | null; cycleTimeSeconds: number | null
  pressureBar: number | null; wallThicknessMm: number | null; qualityToleranceNotes: string | null
  lines: SaveBomLinePayload[]
}

export const listBoms = () => api.get<BomListItem[]>('/productie/retetar').then((r) => r.data)
export const getBom = (id: string) => api.get<BomDetail>(`/productie/retetar/${id}`).then((r) => r.data)
export const getBomHistory = (id: string) => api.get<BomHistoryEntry[]>(`/productie/retetar/${id}/istoric`).then((r) => r.data)
export const createBom = (payload: SaveBomPayload) => api.post<{ id: string }>('/productie/retetar', payload).then((r) => r.data)
export const updateBom = (id: string, payload: SaveBomPayload) => api.put(`/productie/retetar/${id}`, payload)
export const createBomVersion = (id: string, changeReason: string | null) =>
  api.post<{ id: string }>(`/productie/retetar/${id}/versiune-noua`, { changeReason }).then((r) => r.data)
export const submitBomForApproval = (id: string) =>
  api.post<{ pendingApproval: boolean }>(`/productie/retetar/${id}/submit-aprobare`).then((r) => r.data)
export const archiveBom = (id: string) => api.post(`/productie/retetar/${id}/arhiveaza`)
